/**
 * « Djinn des mirages », the desert's shop pack (ADR 0031): deep blue silk
 * and gold, wisps of blue smoke off the shoulders and hands, a scimitar, a
 * brass lamp and a flying carpet. Worn pieces drawn on the body (ADR 0006,
 * 0014) and animated like the fire set; held pieces derived from their icon
 * (ADR 0005). Nothing of the pharaoh's loot set: no nemes, no khopesh.
 */
const piece = (id, name, slot) => ({
    id,
    lootable: false,
    cosmetic: true,
    name,
    kind: 'equipment',
    slot,
    rarity: 'epic',
    ...(slot === 'offhand' ? { classes: ['warrior'] } : {}),
    sprite: `overlay.${id}`,
    icon: `icon.${id}`,
});
const single = (id, name, blurb, priceCents) => ({
    id,
    name,
    blurb,
    pack: 'djinn',
    items: [{ templateId: id }],
    priceCents,
});
const PIECES = [
    [
        'djinn-scimitar',
        'Cimeterre du djinn',
        'Une lame courbe d’acier bleu à la garde d’or, portée par-dessus ton arme.',
        399,
    ],
    [
        'djinn-turban',
        'Turban du djinn',
        'Un turban de soie bleu nuit ceint d’or, un joyau d’or au front.',
        299,
    ],
    [
        'djinn-vest',
        'Soieries du djinn',
        'Une tunique de soie bleue brodée d’or, nouée d’une ceinture dorée, la fumée aux épaules. Animée.',
        399,
    ],
    [
        'djinn-bracers',
        'Brassards du djinn',
        'Des brassards d’or d’où s’enroulent des volutes de fumée bleue. Animés.',
        199,
    ],
    [
        'djinn-slippers',
        'Babouches du djinn',
        'Des babouches de soie bleue aux pointes d’or recourbées.',
        199,
    ],
    [
        'djinn-lamp',
        'Lampe du djinn',
        'Une lampe de laiton poli dont le bec laisse filer une fumée bleue. Animée.',
        299,
    ],
];
const CARPET_PRICE = 599;
export const DJINN = {
    templates: [
        piece('djinn-scimitar', 'Cimeterre du djinn', 'weapon'),
        piece('djinn-turban', 'Turban du djinn', 'helmet'),
        piece('djinn-vest', 'Soieries du djinn', 'chest'),
        piece('djinn-bracers', 'Brassards du djinn', 'gloves'),
        piece('djinn-slippers', 'Babouches du djinn', 'boots'),
        piece('djinn-lamp', 'Lampe du djinn', 'offhand'),
        {
            id: 'flying-carpet',
            lootable: false,
            name: 'Tapis volant',
            kind: 'equipment',
            slot: 'mount',
            rarity: 'legendary',
            companion: 'flying-carpet',
            icon: 'icon.flying-carpet',
        },
    ],
    offers: [
        ...PIECES.map(([id, name, blurb, price]) => single(id, name, blurb, price)),
        single('flying-carpet', 'Tapis volant', 'Un tapis de soie bleue et or qui flotte au-dessus du sable et te porte deux fois plus vite que tes jambes. Animé.', CARPET_PRICE),
        {
            id: 'djinn-pack',
            name: 'Pack du Djinn des mirages',
            blurb: 'Les six pièces du djinn (cimeterre, turban, soieries, brassards, babouches et lampe) et le tapis volant, par-dessus ton équipement.',
            pack: 'djinn',
            items: [...PIECES.map(([id]) => ({ templateId: id })), { templateId: 'flying-carpet' }],
            priceCents: 999,
            worthCents: PIECES.reduce((sum, [, , , price]) => sum + price, CARPET_PRICE),
        },
    ],
};
//# sourceMappingURL=djinn.js.map